var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_title"},[_c('span',{staticClass:"t_es"},[_vm._v(_vm._s(_vm.titleEn)+" ")]),_c('span',{staticClass:"t_zh"},[_vm._v(_vm._s(_vm.titleZh))])])
}
var staticRenderFns = []

export { render, staticRenderFns }